"use strict";

var Dispatcher = require('flux').Dispatcher;

class AppDispatcher extends Dispatcher {
	constructor() {
		super();
		this._isDispatching = false;
	}

	dispatch(action) {
		var dispatchArguments = arguments;
		if (this._isDispatching) {
			// HACK: does not guarantee ordering of dispatches
			var timer = setInterval(() => {
				if (!this._isDispatching) {
					clearInterval(timer);
					super.dispatch.apply(this, dispatchArguments);
				}
			}, 100);
		} else {
			super.dispatch.apply(this, dispatchArguments);
		}
	}
}

module.exports = new AppDispatcher();
